/* eslint-disable prettier/prettier */
export default class FileUtils {
  validateFile(files) {
    if (files.length === 0) {
    return { valid: false, message: "Please select a valid image file" };
    }

    if (files[0].size / 1000000 > 4) {
    return { valid: false, message: "Image size should not be more than 4MB" };
    }

    const mimeType = files[0].type;
    if (mimeType !== "image/png" && mimeType !== "image/jpeg" && mimeType !== "image/jpg") {
    return { valid: false, message: "Images should be in the .png, .jpeg and .jpg formats" };
    }

    return { valid: true, message: "" }
  }

  async getSrc(files) {
    let src = "";

    const fileReaderPromise = new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = () => {
            const image = new Image();
            image.src = String(reader.result);
            image.onload = function () {
                src = `url("${reader.result}")`;
                resolve();
            };
        }; 
    });

    await fileReaderPromise;
    return src;
  }
}